<!--
 * @Descripttion: 专区管理-关联项目列表
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="related-project">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { XrkTable, XrkTableProps, useTableColumn } from 'xrk-components';
import { formatter } from '@/utils';
import { relationProject } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    row?: {
      id: number;
      infoType: number;
    };
    hasForm: number;
  }>(),
  {}
);
const xrkTableRef = ref();
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      label: '项目编码',
      prop: 'projectCode'
    }),
    useTableColumn({
      label: '项目名称',
      prop: 'projectName'
    }),
    useTableColumn({
      label: '关联时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    })
  ]
});

const getListAjax = async params => {
  try {
    const restParams = {
      ...params,
      id: props.row?.id,
      hasForm: props?.hasForm
    };

    const res = await relationProject(restParams);

    return res;
  } catch (error) {
    console.log(error);
  }
};
</script>
<style lang="scss">
.related-project {
  padding: 20px;
}
</style>
